import { RootState } from '@types';

export const selectAuthToken = (state: RootState) => state.auth.token;
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const selectWaitForManualAuthInit = (state: RootState) => state.auth.waitForManualAuthInit;
